var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticStyle: { "margin-bottom": "10px" } },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.queryForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("template", { slot: "label" }, [
                            _c(
                              "div",
                              { staticClass: "selectLabel" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "180px" },
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "orderDetails.pleaseChoose"
                                      ),
                                    },
                                    model: {
                                      value: _vm.selectType,
                                      callback: function ($$v) {
                                        _vm.selectType = $$v
                                      },
                                      expression: "selectType",
                                    },
                                  },
                                  [
                                    _c("el-option", {
                                      key: "3",
                                      attrs: {
                                        label: _vm.$t(
                                          "placeOrder.customerNumber"
                                        ),
                                        value: 3,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "1",
                                      attrs: {
                                        label: _vm.$t("newOrder.waybillNumber"),
                                        value: 1,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "2",
                                      attrs: {
                                        label: _vm.$t(
                                          "placeOrder.scanOrderNumber"
                                        ),
                                        value: 2,
                                      },
                                    }),
                                    _c("el-option", {
                                      key: "4",
                                      attrs: { value: 4, label: "NFe秘钥" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("newOrder.PreciseSearch1"),
                              rows: 1,
                              clearable: "",
                              type: "textarea",
                            },
                            model: {
                              value: _vm.queryForm.params.inputValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.queryForm.params,
                                  "inputValue",
                                  $$v
                                )
                              },
                              expression: "queryForm.params.inputValue",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("collectionCenter.pushTime") },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-time": ["00:00:00", "23:59:59"],
                              "end-placeholder": _vm.$t(
                                "operationCenter.endDate"
                              ),
                              "start-placeholder": _vm.$t(
                                "operationCenter.startDate"
                              ),
                              "range-separator": "~",
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                            },
                            on: { change: _vm.dateChange },
                            model: {
                              value: _vm.timeValue,
                              callback: function ($$v) {
                                _vm.timeValue = $$v
                              },
                              expression: "timeValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("receivablePayable.customer"),
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "spareNumberPoo.Only10AreDisplayed"
                                ),
                                "remote-method": _vm.getCustomerPage,
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "reserve-keyword": "",
                              },
                              on: {
                                focus: function ($event) {
                                  return _vm.getCustomerPage()
                                },
                              },
                              model: {
                                value: _vm.queryForm.params.customerId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryForm.params,
                                    "customerId",
                                    $$v
                                  )
                                },
                                expression: "queryForm.params.customerId",
                              },
                            },
                            _vm._l(_vm.customerList, function (item, ind) {
                              return _c("el-option", {
                                key: ind,
                                attrs: {
                                  label:
                                    item.customerAlias +
                                    "(" +
                                    item.username +
                                    ")",
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("orderCenterCont.WhetherSuccessful"),
                            name: "customerId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.queryForm.params.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryForm.params, "state", $$v)
                                },
                                expression: "queryForm.params.state",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.all"),
                                  value: null,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.succeed"),
                                  value: 1,
                                },
                              }),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("GlobalSetObj.Lose"),
                                  value: 0,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.searchResources(1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("operationCenter.Procurar")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-refresh-left", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.searchResources(2)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("operationCenter.reset")) + " ")]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.allExportOrder } },
            [_vm._v(" " + _vm._s(_vm.$t("operationCenter.exports")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData, border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.ind"),
                  align: "center",
                  width: "60px",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              (_vm.queryForm.pageNumber - 1) *
                                _vm.queryForm.pageSize +
                                scope.$index +
                                1
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("collectionCenter.pushTime"),
                  "min-width": "170",
                  prop: "pushTime",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operationCenter.client"),
                  "show-overflow-tooltip": true,
                  align: "left",
                  "min-width": "180",
                  prop: "customerName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.customerName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("placeOrder.customerNumber"),
                  "show-overflow-tooltip": true,
                  align: "left",
                  "min-width": "180",
                  prop: "customerNumber",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-class": "copy",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "font-size": "12px",
                                      padding: "2px",
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copy(
                                          scope.row.customerNumber
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("orderDetails.copy")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "is-click-column",
                                    attrs: { slot: "reference" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.operationBtn(scope.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.customerNumber) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("newOrder.waybillNumber"),
                  "show-overflow-tooltip": true,
                  align: "left",
                  "min-width": "180",
                  prop: "waybillNumber",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-class": "copy",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "font-size": "12px",
                                      padding: "2px",
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copy(scope.row.waybillNumber)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("orderDetails.copy")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.waybillNumber) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("placeOrder.scanOrderNumber"),
                  "show-overflow-tooltip": true,
                  align: "left",
                  "min-width": "180",
                  prop: "scanOrderNumber",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-class": "copy",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "font-size": "12px",
                                      padding: "2px",
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copy(
                                          scope.row.scanOrderNumber
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("orderDetails.copy")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.scanOrderNumber) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.nfeKey"),
                  "min-width": "180",
                  prop: "nfeKey",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top",
                                  "popper-class": "copy",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: {
                                      color: "black",
                                      "font-size": "12px",
                                      padding: "2px",
                                    },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copy(scope.row.nfeKey)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("orderDetails.copy")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [_vm._v(" " + _vm._s(scope.row.nfeKey) + " ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.pushParty"),
                  "min-width": "160",
                  prop: "requestSource",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.pushPartyUrl"),
                  "min-width": "160",
                  prop: "requestUrl",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.receiverParty"),
                  "min-width": "160",
                  prop: "receiverName",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.receiverPartyUrl"),
                  "min-width": "160",
                  prop: "receiverUrl",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("orderCenterCont.ResponseMessages"),
                  "show-overflow-tooltip": false,
                  align: "left",
                  "min-width": "220",
                  prop: "responseParams",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "pre",
                            {
                              staticStyle: {
                                "max-height": "400px",
                                overflow: "auto",
                              },
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [
                              _vm._v(
                                "                " +
                                  _vm._s(scope.row.responseParams) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "paramsStyle" }, [
                            _vm._v(_vm._s(scope.row.responseParams)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.pushMessage"),
                  "show-overflow-tooltip": false,
                  align: "left",
                  "min-width": "220",
                  prop: "originRequestParams",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "pre",
                            {
                              staticStyle: {
                                "max-height": "400px",
                                overflow: "auto",
                              },
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [
                              _vm._v(
                                "                " +
                                  _vm._s(scope.row.originRequestParams) +
                                  "\n              "
                              ),
                            ]
                          ),
                          _c("div", { staticClass: "paramsStyle" }, [
                            _vm._v(_vm._s(scope.row.originRequestParams)),
                          ]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("tablePrice.orderSuccess"),
                  "show-overflow-tooltip": true,
                  align: "center",
                  "min-width": "140",
                  prop: "state",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.state == 0
                          ? _c("el-tag", { attrs: { type: "danger" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("operationCenter.fail")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        scope.row.state == 1
                          ? _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("operationCenter.succeed")) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageNumber", $event)
                  },
                  "update:pageSize": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "update:page-size": function ($event) {
                    return _vm.$set(_vm.queryForm, "pageSize", $event)
                  },
                  "current-change": _vm.getCurrentTableData,
                  "size-change": _vm.getSizeTableData,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            "close-on-click-modal": false,
            title: _vm.$t("orderCenterCont.ViewDetails"),
            visible: _vm.drawerTag,
            "custom-class": "drawerClass",
            direction: "ltr",
            size: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerTag = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "preStyle" },
            [
              _c(
                "el-form",
                {
                  ref: "updateForm",
                  staticStyle: {
                    padding: "0 20px",
                    height: "calc(100vh - 68px)",
                    "overflow-y": "auto",
                  },
                  attrs: { model: _vm.updateForm },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("orderCenterCont.TheOrderNumber") +
                                    "：",
                                  prop: "orderNumber",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.updateForm.customerNumber)),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple-light" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("operationCenter.client") + "：",
                                  prop: "customerName",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.updateForm.customerName)),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple-light" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    _vm.$t("orderCenterCont.RequestTime") +
                                    "：",
                                  prop: "createTime",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.updateForm.pushTime)),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple-light" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("tablePrice.pushMessage")) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "messageCon" }, [
                                  _vm.updateForm.originRequestParams
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            "line-height": "25px",
                                            padding: "5px",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-copy-document",
                                            staticStyle: {
                                              "font-size": "20px",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              title: _vm.$t(
                                                "orderCenterCont.copy"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copy(
                                                  _vm.updateForm
                                                    .originRequestParams
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.updateForm.originRequestParams)
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple-light" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "orderCenterCont.ResponseMessages"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "messageCon" }, [
                                  _vm.updateForm.responseParams
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            "line-height": "25px",
                                            padding: "5px",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-copy-document",
                                            staticStyle: {
                                              "font-size": "20px",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              title: _vm.$t(
                                                "orderCenterCont.copy"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copy(
                                                  _vm.updateForm.responseParams
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.updateForm.responseParams)
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 10 } },
                    [
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple-light" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("tablePrice.anJunOrderMessage")
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "messageCon" }, [
                                  _vm.updateForm.requestParams
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            "line-height": "25px",
                                            padding: "5px",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-copy-document",
                                            staticStyle: {
                                              "font-size": "20px",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              title: _vm.$t(
                                                "orderCenterCont.copy"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copy(
                                                  _vm.updateForm.requestParams
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(_vm.updateForm.requestParams)
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("el-col", { attrs: { span: 12 } }, [
                        _c(
                          "div",
                          { staticClass: "grid-content bg-purple-light" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "tablePrice.anJunOrderResponseMessage"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c("div", { staticClass: "messageCon" }, [
                                  _vm.updateForm.originResponseParams
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            "line-height": "25px",
                                            padding: "5px",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-copy-document",
                                            staticStyle: {
                                              "font-size": "20px",
                                              cursor: "pointer",
                                            },
                                            attrs: {
                                              title: _vm.$t(
                                                "orderCenterCont.copy"
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copy(
                                                  _vm.updateForm
                                                    .originResponseParams
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("pre", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.updateForm.originResponseParams
                                      )
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }